/** @file tileParseHex: reads `#rgb`, `#rrggbb` or `#rrggbbaa` (the `#` optional) into a colour. */
import type { Rgba } from '@zilo/pose3d-image-io/types/image';

/** The colour, opaque unless eight digits give the alpha; null for anything else. */
export function tileParseHex(text: string): Rgba | null {
  const raw = text.trim().replace(/^#/, '').toLowerCase();
  if (!/^([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(raw)) return null;
  const full = raw.length === 3 ? raw.replace(/./g, '$&$&') : raw;
  const byte = (i: number): number => parseInt(full.slice(i * 2, i * 2 + 2), 16);
  return [byte(0), byte(1), byte(2), full.length === 8 ? byte(3) : 255];
}
